'use client';

import React, { useState, useEffect } from 'react';

interface HeaderProps {
  onBookClick: () => void;
}

export default function Header({ onBookClick }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 px-6 md:px-10 h-16 flex items-center justify-between transition-all duration-500 ${
        scrolled ? 'nav-scrolled' : 'bg-transparent'
      }`}
    >
      <div className="flex items-center gap-2">
        <span className="font-mono text-[0.85rem] font-bold tracking-[0.18em] uppercase text-concrete">
          Hvz<span className="text-coral">.photos</span>
        </span>
      </div>

      <nav className="hidden md:flex items-center gap-10">
        <a href="#about" className="font-mono text-[0.6rem] font-bold tracking-[0.3em] uppercase text-concrete/50 hover:text-concrete transition-colors">
          About
        </a>
        <a href="#work" className="font-mono text-[0.6rem] font-bold tracking-[0.3em] uppercase text-concrete/50 hover:text-concrete transition-colors">
          Work
        </a>
        <a href="#contact" className="font-mono text-[0.6rem] font-bold tracking-[0.3em] uppercase text-concrete/50 hover:text-concrete transition-colors">
          Contact
        </a>
      </nav>

      <button
        onClick={onBookClick}
        className="btn-coral text-[0.62rem]"
        aria-label="Book a session"
      >
        Book a Session
      </button>
    </header>
  );
}